import React from 'react';
import PropTypes from 'prop-types';
import './bannerNotifications.less';
import { Icon } from 'edcom-ui';

const BannerNotification = ({ html, id, readOne, deleteOne, removable }) => {
  const catchError = err => {
    console.error(err);
  };

  const handleClick = (event, id) => {
    let element = event.target.closest('[data-href]');

    if (!element) {
      return;
    }

    const { href } = element.dataset;

    if (!href) {
      return;
    }

    const matches = href.match(/\/([^/]+)$/);

    if (matches.length < 2) {
      return;
    }

    readOne(id, matches[1])
      .then(redirectUrl => {
        window.location = redirectUrl;
      })
      .catch(catchError);
  };

  const handleDeleteOne = () => {
    deleteOne(id).catch(catchError);
  };

  return (
    <div className="banner-wrapper">
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        onClick={event => {
          handleClick(event, id);
        }}
      />
      {removable && <Icon name="cancel-light" onClick={handleDeleteOne} />}
    </div>
  );
};

export default BannerNotification;

BannerNotification.propTypes = {
  html: PropTypes.node,
  id: PropTypes.string,
  readOne: PropTypes.func,
  deleteOne: PropTypes.func,
  removable: PropTypes.bool,
};
